<template>
    <v-container>
        <h1 class="mb-6">{{ metaData.header }}</h1>

        <v-tabs
            v-model="tab"
            color="orange lighten-2"
            centered
            background-color="transparent"
        >
            <v-tab v-for="category in categories" :key="category.id">{{ category.name }}</v-tab>
        </v-tabs>

        <div class="text-right">
            <v-btn elevation="0" text color="orange lighten-2" @click="addProduct">
                <div class="d-flex align-center">
                    <v-icon>add</v-icon>
                    <span class="pl-6">{{ $t('addingProduct') }}</span>
                </div>
            </v-btn>
        </div>

        <v-tabs-items v-model="tab" class="py-7 transparent">
            <v-tab-item v-for="category in categories" :key="category.id">

                <products-cards
                    :products="getProductsByCategoryId(category.id)"
                    @click-product="productClickHandler"
                    @add-product="addProduct"
                    @remove-product="productRemoveHandler"
                ></products-cards>

                <products-params
                    :products="getProductsByCategoryId(category.id)"
                ></products-params>

            </v-tab-item>
        </v-tabs-items>

        <auth-dialog :is-open="$store.state.account.showLoginDialog"></auth-dialog>
    </v-container>
</template>

<script>
    import Auth from '../../../app-front/mixins/Auth';
    import AuthDialog from '../../../app-front/components/dialogs/AuthDialog';
    import ProductsCards from './ProductsCards';
    import ProductsParams from './ProductsParams';
    import ProductsCompare from '../../../app-front/mixins/ProductsCompare';
    import ProductsAttributes from '../../../app-front/mixins/ProductsAttributes';

    export default {
        name: 'ProductsCompare',
        components: {
            AuthDialog,
            ProductsCards,
            ProductsParams,
        },
        mixins: [Auth, ProductsCompare, ProductsAttributes],
        data() {
            return {
                metaUrl: '/products-compare',
                tab: null,
                products: [],
            }
        },
        methods: {
            setProducts() {
                this.getList().then(products => {
                    this.products = products.map(product => {
                        return {
                            ...product,
                            data: this.getTransformedEnumAttributes(product.attributes),
                        }
                    });
                });
            },
            productClickHandler(id) {
                this.$router.push(this.getProductRoute(id));
            },
            getProductRoute(id) {
                const product = this.products.find(product => product.id === id);
                const category = product.category;

                return `/products/${ category.parentSystemName }/${ category.systemName }/${ product.productSystemName }-${ product.id }`;
            },
            addProduct() {
                const currentCategory = this.categories[this.tab];
                const base = '/categories';

                if (currentCategory) {
                    this.$router.push(`${ base }/${ currentCategory.parentSystemName }/${ currentCategory.systemName }`);
                } else {
                    this.$router.push(base);
                }
            },
            getProductsByCategoryId(id) {
                return this.products.filter(product => product.category.id === id);
            },
            productRemoveHandler(id) {
                this.removeFromCompare(id).then(() => {
                    this.products = this.products.filter(product => product.id !== id);
                })
            },
        },
        computed: {
            categories() {
                const categories = this.products.map(product => product.category);

                return _.uniqBy(categories, 'id');
            },
        },
        mounted() {
            if(!this.isAuthChecked)
                return;

            this.setProducts();

        },
        watch: {
            isAuthChecked() {
                this.setProducts();
            }
        }
    }
</script>

<style scoped>

</style>
